import React from 'react';
import './src/styles/reset.css';
import './src/styles/main.scss';

export const wrapRootElement = ({ element }) => <>{element}</>;
